<template>
    <div class="flex justify-center">
        <div class="btn-group flex items-center ">
            <button class="btn btn-primary btn-xs" :disabled="model?.pageNumber===0" @click="previousPage">
                «
            </button>
            <div class="px-3 text-lg font-bold h-12 flex items-center">
                {{ model?.pageNumber + 1 }}
            </div>
            <button
                class="btn btn-primary btn-xs"
                :disabled="model?.pageNumber===(model?.totalPages - 1) || model?.totalPages === 0"
                @click="nextPage"
            >
                »
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import {emptyPage, Page} from '@/types/Page'

const model = defineModel<Page<any>>({
    default: emptyPage
})

const previousPage = () => model.value = ({
    ...model.value,
    pageNumber: model.value.pageNumber -= 1
})
const nextPage = () => model.value = ({
    ...model.value,
    pageNumber: model.value.pageNumber += 1
})
</script>

<style>

</style>